export default {
    modal: ({modals_info}) => modals_info.modal 
}